<micro-lookup domain="smppserver" obj="smppServerClients" url="/smppserver/smppServerClients" [key]="smppServerClientId"></micro-lookup>
